import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'holidayTypes',
    standalone: false
})
export class HolidayTypesPipe implements PipeTransform {

  public transform = (value: number): string => {
    switch (value)
    {
      case 1:
        return 'Public Holiday';
      case 2:
        return 'RDO';
      case 3:
        return 'Annual Leave';
      default:
        return '';
    }
  }
}